
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
//import "core-js/stable";
//import "regenerator-runtime/runtime";

require('./bootstrap');
require('select2');
//require('fullcalendar');
//require('../fullcalendar/locale-all');
try {
    require('trix');
}
 catch (e) {
    console.log('trix err');
 }
require('./settings');
require("./functions.js");
require("./nav.js");
// require('tempusdominus-bootstrap-4');
require('./tempusdominus-bootstrap-4-with-fixes.min')

import {toggleCheckboxes} from './helpers.js';
window.toggleCheckboxes = toggleCheckboxes;